/**
 * Input validation handlers for restricting keyboard input on form fields.
 * Use as onKeyDown handlers on <input> elements.
 */

// Letters, spaces, hyphens, apostrophes, periods, and ñ/Ñ only (for name fields)
export const lettersOnly = (e) => {
  if (e.ctrlKey || e.metaKey) return;
  const key = e.key;
  if (key.length === 1 && !/[a-zA-ZñÑ\s\-'.]/.test(key)) {
    e.preventDefault();
  }
};

// Digits and decimal point only (for numeric text fields)
export const numbersOnly = (e) => {
  if (e.ctrlKey || e.metaKey) return;
  const key = e.key;
  if (key.length === 1 && !/[0-9.]/.test(key)) {
    e.preventDefault();
  }
};

// Digits and slash only (for blood pressure format like 120/80)
export const numbersWithSlash = (e) => {
  if (e.ctrlKey || e.metaKey) return;
  const key = e.key;
  if (key.length === 1 && !/[0-9/]/.test(key)) {
    e.preventDefault();
  }
};

// Digits and dash only (for ID numbers like PhilHealth)
export const numbersWithDash = (e) => {
  if (e.ctrlKey || e.metaKey) return;
  const key = e.key;
  if (key.length === 1 && !/[0-9-]/.test(key)) {
    e.preventDefault();
  }
};
